"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get LabResultFlagSchema () {
        return LabResultFlagSchema;
    },
    get LabResultListItemSchema () {
        return LabResultListItemSchema;
    },
    get LabResultListQuerySchema () {
        return LabResultListQuerySchema;
    },
    get LabResultListResponseSchema () {
        return LabResultListResponseSchema;
    },
    get LabResultMatchedBySchema () {
        return LabResultMatchedBySchema;
    },
    get LabResultReviewResponseSchema () {
        return LabResultReviewResponseSchema;
    },
    get LabResultSchema () {
        return LabResultSchema;
    },
    get LabResultStatusSchema () {
        return LabResultStatusSchema;
    }
});
const _zod = require("zod");
const LabResultFlagSchema = _zod.z.enum([
    'high',
    'low',
    'normal',
    'abnormal',
    'unknown'
]);
const LabResultStatusSchema = _zod.z.enum([
    'new',
    'reviewed'
]);
const LabResultMatchedBySchema = _zod.z.enum([
    'philhealth_pin',
    'oem_patient_ref',
    'manual'
]);
/** Fields of one lab result. See `LabResultSchema` for the PHI rules. */ const labResultShape = {
    id: _zod.z.string().uuid(),
    testName: _zod.z.string(),
    resultSummary: _zod.z.string(),
    flag: LabResultFlagSchema,
    status: LabResultStatusSchema,
    receivedAt: _zod.z.string().datetime({
        offset: true
    }),
    resultedAt: _zod.z.string().datetime({
        offset: true
    }).nullable(),
    sourceOem: _zod.z.string(),
    via: _zod.z.string(),
    matchedBy: LabResultMatchedBySchema,
    reviewedAt: _zod.z.string().datetime({
        offset: true
    }).nullable()
};
/** `status === 'reviewed'` exactly when `reviewedAt` is set. */ function checkReviewPair(result, ctx) {
    const isReviewed = result.status === 'reviewed';
    const hasReviewedAt = result.reviewedAt !== null;
    if (isReviewed !== hasReviewedAt) {
        ctx.addIssue({
            code: 'custom',
            path: [
                'reviewedAt'
            ],
            message: 'reviewedAt must be set if and only if status is reviewed.'
        });
    }
}
const LabResultSchema = _zod.z.object(labResultShape).strict().superRefine(checkReviewPair);
const LabResultListItemSchema = _zod.z.object({
    ...labResultShape,
    attachmentCount: _zod.z.number().int().min(0)
}).strict().superRefine(checkReviewPair);
const LabResultListQuerySchema = _zod.z.object({
    page: _zod.z.coerce.number().int().min(1).default(1),
    pageSize: _zod.z.coerce.number().int().min(1).max(50).default(20)
}).strict();
const LabResultListResponseSchema = _zod.z.object({
    items: _zod.z.array(LabResultListItemSchema),
    page: _zod.z.number().int().min(1),
    pageSize: _zod.z.number().int().min(1).max(50),
    total: _zod.z.number().int().min(0),
    gatewayEnabled: _zod.z.boolean()
}).strict();
const LabResultReviewResponseSchema = LabResultSchema;
